// extracted by mini-css-extract-plugin
module.exports = {"surfCurveChartWrapper":"SurfCurveChart_surfCurveChartWrapper__Syz40","surfCurveChart":"SurfCurveChart_surfCurveChart__tOykI"};